export default "/images/slider-6.jpg?9a0ec443d5c9477be1d603af9d1dc15f";